import { Component } from '.';
import { Transform, BoxDimensions, Color } from '../../interfaces';
import { TransformPosition } from '../..';

/**
 * Mesh renderer component.
 */
export class MeshRenderer extends Component {
	public state: {
		mesh?: string | BoxDimensions;
		visibility?: number;
		transform?: Transform;
		overlayColor: Color;
		enableOverlay?: boolean;
		screenOffset?: TransformPosition;
	} = {
		visibility: 1,
		transform: { position: { x: 0, y: 0, z: 0 } },
		overlayColor: { r: 1, g: 1, b: 1 },
	};

	public getScreenPosition: (forceUpdate?: boolean) => { x: number; y: number } = () => {
		// This is just a default implementation, will be overriden
		return { x: 0, y: 0 };
	};
}
